import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import { AdminCheckbox } from 'shared-components';
import styles from './ShippingRestrictions.module.css';

const shippingRestrictionsList = [
  {
    label: 'Canada',
    value: 'ca',
  },
  {
    label: 'Domestic',
    value: 'domestic',
    includeValues: ['alcohol_restricted'],
  },
  {
    label: 'Domestic Alcohol (GA, ID, MS, NE, SC, KS, FL)',
    value: 'alcohol_restricted',
  },
  {
    label: 'France',
    value: 'fr',
  },
  {
    label: 'Germany',
    value: 'de',
  },
  {
    label: 'Hazardous',
    value: 'ormd_restricted',
  },
  {
    label: 'Ireland',
    value: 'ie',
  },
  {
    label: 'Military',
    value: 'military',
  },
  {
    label: 'Non-Continental',
    value: 'hi_ak',
  },
  {
    label: 'Puerto Rico',
    value: 'pr',
  },
  {
    label: 'United Kingdom',
    value: 'uk',
  },
];

const hash = {
  ca: 'Canada',
  domestic: 'Domestic',
  alcohol_restricted: 'Domestic Alcohol',
  fr: 'France',
  de: 'Germany',
  ormd_restricted: 'Hazardous',
  ie: 'Ireland',
  military: 'Military',
  hi_ak: 'Non-Continental',
  pr: 'Puerto Rico',
  uk: 'United Kingdom',
};

const ShippingRestrictions = ({ setFormData, shippingRestrictions }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [display, setDisplay] = useState('');
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (shippingRestrictions) setSelected(shippingRestrictions);
    const shippingRestrictionsDisplay = _.map(
      shippingRestrictions,
      (s) => hash[s]
    ).join(', ');
    setDisplay(shippingRestrictionsDisplay);
  }, [shippingRestrictions]);

  const toggleDropdown = () => setIsOpen((prevState) => !prevState);

  const getChangedSelection = (selectedValue) => {
    const selectedCopy = [...selected];
    const targetShippingRestriction = _.find(shippingRestrictionsList, (r) => {
      return r.value === selectedValue;
    });
    if (selectedCopy.includes(selectedValue)) {
      // remove targetShippingRestriction and its includedValues from selected shipping restrictions
      selectedCopy.splice(selectedCopy.indexOf(selectedValue), 1);
      if (targetShippingRestriction.includeValues) {
        targetShippingRestriction.includeValues.forEach((v) => {
          selectedCopy.splice(selectedCopy.indexOf(v), 1);
        });
      }
    } else {
      // add targetShippingRestriction and its includedValues to selected shipping restrictions
      selectedCopy.push(selectedValue);
      if (targetShippingRestriction.includeValues) {
        targetShippingRestriction.includeValues.forEach((v) => {
          selectedCopy.push(v);
        });
      }
    }
    // user uniq remove duplicate selection possibly added if includedValues was already in selected list
    return _.uniq(selectedCopy);
  };

  const handleChange = (e) => {
    const selectedCopy = getChangedSelection(e.target.value);
    setFormData((prevState) => {
      const newState = cloneDeep(prevState);
      return {
        ...newState,
        shippingRestrictions: selectedCopy,
      };
    });
    const newDisplay = _.map(selectedCopy, (s) => hash[s]).join(', ');
    setDisplay(newDisplay);
    setSelected(selectedCopy);
  };

  return (
    <div className={styles.container}>
      <div className={styles.dropdownButtonContainer}>
        <span className={styles.label}>Shipping Restrictions</span>
        <button
          className={styles.select}
          type="button"
          onClick={toggleDropdown}
        >
          <span>{display || 'Select One or More'}</span>
        </button>
      </div>
      <div
        className={`${styles.checkboxContainer} ${isOpen ? styles.open : ''} `}
        onMouseLeave={() => setIsOpen(false)}
      >
        {_.map(shippingRestrictionsList, (s) => {
          return (
            <AdminCheckbox
              value={s.value}
              checked={selected.includes(s.value)}
              label={s.label}
              onChange={handleChange}
              key={s.value}
            />
          );
        })}
      </div>
    </div>
  );
};

ShippingRestrictions.propTypes = {
  setFormData: PropTypes.func.isRequired,
  shippingRestrictions: PropTypes.arrayOf(PropTypes.string),
};

ShippingRestrictions.defaultProps = {
  shippingRestrictions: null,
};

export default ShippingRestrictions;
